import { createTransaction, getComputeUnitLimitInstruction, getComputeUnitPriceInstruction, simulateTransaction, } from '../../base';
export async function makeTransaction({ createTxnData, blockhash, payerKey, connection, getPriorityFee, }) {
    const { instructions, signers, lookupTables, accounts, params } = createTxnData;
    const simulationResult = await simulateTransaction({
        connection,
        instructions,
        lookupTables,
        payerKey,
        accounts,
        params,
    });
    const computeUnitLimitIxn = getComputeUnitLimitInstruction(simulationResult.unitsConsumed);
    const priorityFee = await getPriorityFee({ txnParams: createTxnData, connection });
    const computeUnitPriceIxn = getComputeUnitPriceInstruction(priorityFee);
    const transaction = await createTransaction({
        createTxnData: {
            instructions: [computeUnitLimitIxn, computeUnitPriceIxn, ...instructions],
            lookupTables,
            signers,
            accounts,
            params,
        },
        blockhash,
        payerKey,
        connection,
    });
    return { transaction, accountInfoByPubkey: simulationResult.accountInfoByPubkey, params };
}
